import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import Contact from './pages/Contact';
import About from './pages/About';
import HannyaLogin from './hannya/HannyaLogin';
import HannyaDashboard from './hannya/HannyaDashboard';

// Componente para resetar scroll ao navegar
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [pathname]);

  return null;
}

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    const auth = localStorage.getItem('hannyaAuth');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handleLogin = () => {
    setIsAuthenticated(true);
    navigate('/hannya');
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('hannyaAuth');
    navigate('/');
  };

  const getCurrentPage = () => {
    const path = location.pathname;
    if (path === '/') return 'home';
    if (path === '/sobre') return 'about';
    if (path === '/contato') return 'contact';
    return 'home';
  };

  const currentPage = getCurrentPage();
  const isHannyaRoute = location.pathname === '/hannya';

  const HomePage = () => (
    <>
      <section className="hero">
        <div className="hero-content">
          <span className="badge">✦ React · Node · MongoDB</span>
          <h1>
            <span className="hero-gradient">Soluções web</span><br />
            que impressionam
          </h1>
          <p>
            Da ideia ao deploy: e-commerces escaláveis, portfolios interativos e sistemas personalizados. 
            Tecnologia moderna com design sofisticado.
          </p>
          <div className="tech-stack">
            <span className="tech-badge"><i className="fab fa-react"></i> React</span>
            <span className="tech-badge"><i className="fab fa-node-js"></i> Node.js</span>
            <span className="tech-badge"><i className="fas fa-database"></i> MongoDB</span>
          </div>
        </div>
        <div className="hero-visual">
          <div className="code-card">
            <div className="code-line"><span className="line-number">1</span> <span className="code-accent">import</span> React <span className="code-accent">from</span> <span style={{color: '#2d2d3a'}}>'react'</span></div>
            <div className="code-line"><span className="line-number">2</span> <span style={{color: '#6b7280'}}>// Survows · full‑stack</span></div>
            <div className="code-line"><span className="line-number">3</span> <span className="code-accent">const</span> <span style={{color: '#2563eb'}}>App</span> = () =&gt; {'{'}</div>
            <div className="code-line"><span className="line-number">4</span> &nbsp;&nbsp;<span className="code-accent">return</span> (</div>
            <div className="code-line"><span className="line-number">5</span> &nbsp;&nbsp;&nbsp;&nbsp;&lt;<span style={{color: '#4f46e5'}}>Survows</span> /&gt;</div>
            <div className="code-line"><span className="line-number">6</span> &nbsp;&nbsp;)</div>
            <div className="code-line"><span className="line-number">7</span> {'}'}</div>
          </div>
          <div className="gif-container">
            <img 
              src={isMobile ? "/images/mobile.gif" : "/images/desktop.gif"}
              alt="Coding animation"
              className="side-gif"
            />
          </div>
        </div>
      </section>

      <section>
        <h2 className="section-title">o que fazemos</h2>
        <div className="section-sub">Especialistas em experiências digitais de alto impacto</div>
        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon"><i className="fas fa-shopping-cart"></i></div>
            <h3>E‑commerce</h3>
            <p>Lojas virtuais rápidas, seguras e com experiência de compra impecável. Integração com gateways e painel customizado.</p>
          </div>
          <div className="service-card">
            <div className="service-icon"><i className="fas fa-palette"></i></div>
            <h3>Portfólio</h3>
            <p>Sites que contam sua história. Design único, animações fluidas e performance para destacar seu trabalho.</p>
          </div>
          <div className="service-card">
            <div className="service-icon"><i className="fas fa-code-branch"></i></div>
            <h3>Web Apps</h3>
            <p>Sistemas sob medida com React + Node + MongoDB. Dashboards, SaaS e plataformas escaláveis.</p>
          </div>
        </div>
      </section>

      <section className="portfolio-mini">
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '40px'}}>
          <h2 className="section-title" style={{marginBottom: 0}}>projetos recentes</h2>
          <a href="#" style={{color: 'var(--accent)', fontWeight: '500', textDecoration: 'none'}}>ver todos <i className="fas fa-arrow-right"></i></a>
        </div>
        <div className="portfolio-grid">
          <a href="https://www.snoules.com" target="_blank" rel="noopener noreferrer" className="portfolio-item-link">
            <div className="portfolio-item">
              <div className="portfolio-img">
                <img 
                  src="/images/snoules.png"
                  alt="Snoules - Marca de roupa"
                  className="portfolio-image"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = 'none';
                    e.target.parentElement.querySelector('.portfolio-img-overlay').style.opacity = '1';
                  }}
                />
                <div className="portfolio-img-overlay">
                  <i className="fas fa-external-link-alt"></i> Visitar
                </div>
              </div>
              <div className="portfolio-info">
                <h4>Snoules</h4>
                <span className="portfolio-tag">E-commerce · Moda</span>
                <p className="portfolio-description">Marca de roupa com gerenciamento de pedidos, produtos e usuários.</p>
              </div>
            </div>
          </a>
          <a href="https://tradeghost.netlify.app" target="_blank" rel="noopener noreferrer" className="portfolio-item-link">
            <div className="portfolio-item">
              <div className="portfolio-img">
                <img 
                  src="/images/naute.png"
                  alt="Naute - Corretora de Criptomoeda"
                  className="portfolio-image"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = 'none';
                    e.target.parentElement.querySelector('.portfolio-img-overlay').style.opacity = '1';
                  }}
                />
                <div className="portfolio-img-overlay">
                  <i className="fas fa-external-link-alt"></i> Visitar
                </div>
              </div>
              <div className="portfolio-info">
                <h4>Naute</h4>
                <span className="portfolio-tag">Criptomoeda · Blockchain</span>
                <p className="portfolio-description">Corretora de criptomoeda com conexão blockchain, wallets e perfil privado.</p>
              </div>
            </div>
          </a>
        </div>
      </section>

      <div className="cta-section">
        <h2>Pronto para tirar sua ideia do papel?<br />Vamos conversar.</h2>
        <button className="btn-light" onClick={() => navigate('/contato')}>Solicitar contato <i className="fas fa-arrow-right"></i></button>
      </div>
    </>
  );

  // Se for rota do hannya, renderiza APENAS o painel (sem header/footer do site)
  if (isHannyaRoute) {
    if (isAuthenticated) {
      return <HannyaDashboard onLogout={handleLogout} />;
    }
    return <HannyaLogin onLogin={handleLogin} />;
  }

  // Site público com header e footer
  return (
    <>
      <ScrollToTop />
      <div className="container">
        <header>
          <nav className="navbar">
            <div className="logo" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>
              <img src="/logo.png" alt="Survows" style={{ height: '40px', width: 'auto' }} />
            </div>
            <button className="menu-toggle" onClick={toggleMenu} aria-label="Menu">
              <i className={menuOpen ? "fas fa-times" : "fas fa-bars"}></i>
            </button>
            <div className={`nav-links ${menuOpen ? 'active' : ''}`}>
              <a href="#" className={currentPage === 'home' ? 'active' : ''} onClick={(e) => { e.preventDefault(); navigate('/'); closeMenu(); }}>Home</a>
              <a href="#" className={currentPage === 'about' ? 'active' : ''} onClick={(e) => { e.preventDefault(); navigate('/sobre'); closeMenu(); }}>Sobre</a>
              <a href="#" className={currentPage === 'contact' ? 'active' : ''} onClick={(e) => { e.preventDefault(); navigate('/contato'); closeMenu(); }}>Contato</a>
              <button className="btn-outline" onClick={() => { navigate('/contato'); closeMenu(); }}>Orçamento <i className="fas fa-arrow-right" style={{marginLeft: '8px'}}></i></button>
            </div>
          </nav>
        </header>

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/sobre" element={<About />} />
          <Route path="/contato" element={<Contact />} />
        </Routes>

        <footer className="footer">
          <div>© 2026 Survows — desenvolvimento web sofisticado</div>
         <div className="social">
        <a href="https://www.instagram.com/survows" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
        <a href="https://www.linkedin.com/in/survows" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a>
        <a href="https://github.com/survows" target="_blank" rel="noopener noreferrer"><i className="fab fa-github"></i></a>
       </div>
        </footer>
      </div>
    </>
  );
}

export default App;